export enum AccessType {
	Nobody = 0,
	Everybody = 1
}